import { F, T } from "../../theme/tokens";

// ── Section label ─────────────────────────────────────────────────────────────

export function SectionLabel({ children }: { children: React.ReactNode }) {
  return <p className="section-label" style={{ fontSize: "9px", fontWeight: 700, letterSpacing: "0.12em", color: T.muted, fontFamily: F, textTransform: "uppercase", marginBottom: "12px" }}>{children}</p>;
}
